export const convertNumber = (a: number | string) => {
  if (typeof a === 'string') {
    return Number(a.replaceAll(',', ''));
  }
  return a;
};
